import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FileText, Mail, Users, LogOut } from 'lucide-react';

export default function SpoletoDashboardPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('adminToken') || localStorage.getItem('spoleto_admin_auth');
    if (!token) {
      navigate('/spoleto');
      return;
    }
    
    const userInfo = localStorage.getItem('adminInfo');
    if (userInfo) {
      setUser(JSON.parse(userInfo));
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminAuth');
    localStorage.removeItem('adminInfo');
    navigate('/spoleto');
  };

  if (!user) return null;

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
            <a href="https://getbenefitsavings.com">
              <img src="https://getbenefitsavings.com/logo.png" alt="GetBenefitSavings" className="h-12 w-auto" />
            </a>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">GetBenefitSavings Portal</h1>
              <p className="text-gray-600">Welcome, {user.name || user.email}</p>
            </div>
          </div>
          <div className="flex gap-4">
            <a href="https://getbenefitsavings.com" className="flex items-center gap-2 text-gray-600 hover:text-gray-900">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
              Home
            </a>
            <button onClick={handleLogout} className="flex items-center gap-2 text-gray-600 hover:text-gray-900">
              <LogOut size={20} />
              Logout
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <Link to="/spoleto/articles" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
            <FileText className="text-blue-600 mb-4" size={32} />
            <h2 className="text-xl font-bold mb-2">Articles</h2>
            <p className="text-gray-600">Manage blog posts and content</p>
          </Link>

          <Link to="/spoleto/newsletter" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
            <Users className="text-green-600 mb-4" size={32} />
            <h2 className="text-xl font-bold mb-2">Subscribers</h2>
            <p className="text-gray-600">View newsletter subscribers</p>
          </Link>

          <Link to="/spoleto/mailing-lists" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
            <Mail className="text-purple-600 mb-4" size={32} />
            <h2 className="text-xl font-bold mb-2">Mailing Lists</h2>
            <p className="text-gray-600">Manage mailing lists</p>
          </Link>
          <Link to="/spoleto/categories" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
            <svg className="text-orange-600 mb-4" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg>
            <h2 className="text-xl font-bold mb-2">Categories</h2>
            <p className="text-gray-600">Manage article categories</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
